module.exports = __webpack_public_path__ + "static/media/sap.bff9d829.webp";